
export const adminRole = 1